import httpClient from "./httpClient";
import { Group, RemoveFromGroup } from "../types/groups";

const END_POINT = "/hospitals";

const getGroup = async (
	hospitalid: number,
	groupid: number
): Promise<Group | undefined> => {
	const response = await httpClient.get(
		`${END_POINT}/${hospitalid}/groups/${groupid}`
	);
	return response.data as Group;
};

const postGroup = async (
	hospitalid: number,
	group: Group
): Promise<Group | undefined> => {
	const response = await httpClient.post(
		`${END_POINT}/${hospitalid}/groups`,
		group
	);
	return response.data as Group;
};

const putGroup = async (
	hospitalid: number,
	group: Group
): Promise<Group | undefined> => {
	const { id: groupid } = group;
	const response = await httpClient.put(
		`${END_POINT}/${hospitalid}/groups/${groupid}/`,
		group
	);
	return response.data as Group;
};

const postGroupUser = async (
	hospitalid: number,
	userid: number,
	groupid: number
) => {
	const response = await httpClient.post(
		`${END_POINT}/${hospitalid}/groups/${groupid}/user/${userid}`
	);
	return response.data;
};
const deleteGroupUser = ({ hospitalid, groupid, userid }: RemoveFromGroup) => {
	httpClient.delete(
		`${END_POINT}/${hospitalid}/groups/${groupid}/user/${userid}`
	);
};

export { getGroup, putGroup, postGroup, postGroupUser, deleteGroupUser };
